interface ISetCookie {
  cookieKey: string;
  cookieData: string;
  expires: Date;
  path: string;
}

export function setCookie({
  cookieKey,
  cookieData,
  expires,
  path = '/',
}: ISetCookie) {
  document.cookie = `${cookieKey}=${cookieData};expires=${expires};path=${path};domain=.amagi.tv`;
}

export function getCookie<T>(cookieKey: string): T | null {
  const name = cookieKey + '=';
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return JSON.parse(c.substring(name.length, c.length));
    }
  }
  return null;
}

export function deleteCookie(cookieKey: string) {
  document.cookie = `${cookieKey}=; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;domain=.amagi.tv`;
}
